export default __webpack_public_path__ + "static/media/Map_Lidar.e1c8d6b2.svg";